var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},_vm._l((_vm.imgSrc),function(value,index){return _c('div',{staticClass:"imgDiv"},[_c('el-image',{key:index,staticClass:"img",attrs:{"src":value,"preview-src-list":_vm.imgSrc,"lazy":""}}),_c('div',{staticClass:"imgName"},[_c('span',[_vm._v(_vm._s(_vm.imgName[index]))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }